import type { DataProvider } from '@refinedev/core'

import { i18n } from '../shared/i18n'

import { orderListDataProvider } from './orderListDataProvider'
import { returnListDataProvider } from './returnListDataProvider'
import { cancellationListDataProvider } from './cancellationListDataProvider'
import { productListDataProvider } from './productListDataProvider'
import { settlementHistoryDataProvider } from './settlementHistoryDataProvider'
import { getApiUrl } from '../lib/runtime-env'

function notImplemented(): never {
  throw new Error(i18n.t('common.errors.notImplemented'))
}

const defaultProvider: DataProvider = {
  getList: () => Promise.resolve({ data: [], total: 0 }),
  getOne: notImplemented,
  create: notImplemented,
  update: notImplemented,
  deleteOne: notImplemented,
  getApiUrl,
}

const resourceProviderMap: Record<string, DataProvider> = {
  'order-list': orderListDataProvider,
  'return-list': returnListDataProvider,
  'cancellation-list': cancellationListDataProvider,
  'product-list': productListDataProvider,
  'settlement-history-list': settlementHistoryDataProvider,
}

function getProviderForResource(resource?: string): DataProvider {
  if (!resource) return defaultProvider
  return resourceProviderMap[resource] ?? defaultProvider
}

export const dataProvider: DataProvider = {
  getList: async (params) => {
    return getProviderForResource(params.resource).getList(params)
  },
  getOne: async (params) => {
    return getProviderForResource(params.resource).getOne(params)
  },
  create: async (params) => {
    return getProviderForResource(params.resource).create(params)
  },
  update: async (params) => {
    return getProviderForResource(params.resource).update(params)
  },
  deleteOne: async (params) => {
    return getProviderForResource(params.resource).deleteOne(params)
  },
  getApiUrl,
}
